import { render, staticRenderFns } from "./ScoreDialog.vue?vue&type=template&id=96d0546c&scoped=true"
import script from "./ScoreDialog.vue?vue&type=script&lang=js"
export * from "./ScoreDialog.vue?vue&type=script&lang=js"
import style0 from "./ScoreDialog.vue?vue&type=style&index=0&id=96d0546c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d0546c",
  null
  
)

export default component.exports